import React from 'react';
import { skipToken } from '@reduxjs/toolkit/query/react';
import {
	useAgencyProfessionalQuery,
	useCreateAgencyProfessionalMutation,
	useUpdateAgencyProfessionalMutation
} from '../../../redux/external-agency';
import ProfessionalsEditEmployee from '../../../components/professionals/ProfessionalsEditEmployee';

const AgencyProfessionalsEditEmployee = ({ caregiverId, setEditMode, setShowEditIcon, isCreating = false }) => {
	const { data: professionalData, isLoading: isLoadingProfessional } = useAgencyProfessionalQuery(
		caregiverId ?? skipToken,
		{
			refetchOnMountOrArgChange: true
		}
	);

	const [createProfessional, { isLoading: isLoadingSubmit }] = useCreateAgencyProfessionalMutation();
	const [updateProfessional, { isLoading: isLoadingUpdate }] = useUpdateAgencyProfessionalMutation();

	return (
		<ProfessionalsEditEmployee
			professional={professionalData || {}}
			isLoading={isLoadingProfessional}
			isSaving={isLoadingSubmit || isLoadingUpdate}
			submitProfessional={createProfessional}
			updateProfessional={updateProfessional}
			setEditMode={setEditMode}
			caregiverId={caregiverId}
			isCreating={isCreating}
			setShowEditIcon={setShowEditIcon}
		/>
	);
};

export default AgencyProfessionalsEditEmployee;
